const API_URL = 'https://www.chokhidhani.co.uk/csadmin/api/'
const FRONT_URL =   "https://www.chokhidhani.co.uk/" 
// const API_URL = 'https://studykee.com/24/chokhidhaniuk/csadmin/api/'
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES,FRONT_URL, themesetting };

